import React from "react";
import { CheckCircle2, Heart, Loader2, Plus } from "lucide-react";
import { wishlistService } from "../services";
import type { IWishlist } from "../types";

interface IWishlistSaveListProps {
  folders: IWishlist[];
  /** Folders that already hold the listing: ticked, and a tap removes it from them. */
  savedIn: number[];
  /** A request is in flight for the listing: rows ignore taps. */
  isPending: boolean;
  /** The folder being tapped, which spins. */
  busyFolderId: number | null;
  onSelect: (folder: IWishlist) => void;
  onCreate: () => void;
}

/** The app's "Save to wishlist" sheet body. */
const WishlistSaveList: React.FC<IWishlistSaveListProps> = ({
  folders,
  savedIn,
  isPending,
  busyFolderId,
  onSelect,
  onCreate,
}) => (
  <div className="flex flex-col">
    <ul className="max-h-[50vh] overflow-y-auto border-y border-gray-100 py-2">
      {folders.map((folder) => {
        const isChecked = savedIn.includes(folder.id);
        return (
          <li key={folder.id}>
            <button
              type="button"
              disabled={isPending}
              onClick={() => onSelect(folder)}
              className="flex w-full items-center gap-4 px-6 py-2.5 text-left transition-colors hover:bg-gray-50 disabled:cursor-wait"
            >
              {folder.image ? (
                <img
                  src={folder.image}
                  alt=""
                  className="h-14 w-14 shrink-0 rounded-xl object-cover"
                />
              ) : (
                <span className="flex h-14 w-14 shrink-0 items-center justify-center rounded-xl bg-[#666870]">
                  <Heart size={24} className="text-white" />
                </span>
              )}
              <span className="flex min-w-0 flex-1 flex-col">
                <span className="truncate text-base font-semibold text-ink-black">
                  {folder.name}
                </span>
                <span className="text-sm text-ink-gray">
                  {wishlistService.savedCount(folder)}
                </span>
              </span>
              {busyFolderId === folder.id ? (
                <Loader2 size={22} className="animate-spin text-ink-gray" />
              ) : isChecked ? (
                <CheckCircle2
                  size={22}
                  className="fill-brand-600 text-white"
                  aria-label="Saved here"
                />
              ) : null}
            </button>
          </li>
        );
      })}
    </ul>
    <div className="px-6 pb-6 pt-4">
      <button
        type="button"
        onClick={onCreate}
        disabled={isPending}
        className="flex h-[52px] w-full items-center justify-center gap-2 rounded-xl border border-neutral-900 text-base font-semibold text-ink-black transition-colors hover:bg-gray-50"
      >
        <Plus size={18} />
        Create new wishlist
      </button>
    </div>
  </div>
);

export default WishlistSaveList;
